<template>
  <div class="property align-center-main">
    <div class="header">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>{{ serviceMsg.serviceName }}</el-breadcrumb-item>
        <el-breadcrumb-item>{{ childName }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <ul class="nav clearfix">
      <li v-for="(item, index) in serviceList" :key="index" class="boxShadow" :class="{ 'Select': selectIndex === index }" @click="selectNav(item, index)">
        <img :src="item.picUrl" alt="">
        <span class="textOver2"> {{ item.serviceName }} </span>
      </li>
    </ul>

    <Nothing v-if="!serviceList.length && !loading"></Nothing>
    <div name="content" class="content boxShadow" v-loading="loading" v-show="serviceList.length">
      <div class="rate">
        <ServiceRate :score="score" :totalScoreNum="totalScoreNum"></ServiceRate>
      </div>
      <div v-html="content" class="goodsContent" v-show="isText === 1 || isText === 3" ref="text"></div>
      <div class="myButton button" @click="booking" v-show="isText === 1 || isText === 3">申 请</div>
      <div class="form" v-show="isText === 2">
        <h3>{{ formInfo.formName }}</h3>
        <CustomForm :formObj="formInfo" @finishForm="submitForm" ref="customForm" v-if="isText === 2"></CustomForm>
      </div>
    </div>

    <!-- 模态 -->
    <el-dialog :visible.sync="modalShow" :title="formInfo.formName" width="600px" top="10vh" center>
      <CustomForm :formObj="formInfo" @finishForm="submitForm" ref="customForm" v-if="isText === 3"></CustomForm>
    </el-dialog>

    <SubmitSuccess v-if='submitSuccessFlag' @close='submitSuccessFlag = false;' class='submit-success' :tipsMsg="tipsMsg"></SubmitSuccess>
    <MaskLogin v-show='showLogin' @close='showLogin = false'></MaskLogin>


  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { jsTimestampFilter } from '@/utils/filters.js';
import deepcopy from '@/utils/deepcopy';
import axios from 'axios';

export default {
  data(){
    return{
      totalScoreNum: 0,//总评分人数
      score: 0,//平均评分
      serviceList:[],
      selectIndex: 0, // 控制红边框
      serviceId: 0,
      content: '', // 富文本内容
      formInfo: {},
      submitSuccessFlag: false,
      tipsMsg: '',
      loading: true,
      isText: 0,
      modalShow: false,
      showLogin: false,
      qiniuConfig: {},
      serviceType: '',
      serviceMsg: {},
      childName: '',
      mobile:'',
      userId:'',
      realName:'',
    }
  },
  methods: {
    selectNav(item, index) {  // 点击
      this.selectIndex = index;
      this.serviceId = item.serviceId;
      this.childName = item.serviceName;
      this.getInfo();
      this.$router.push({ path: `/navigator/property/${item.serviceId}`})
      // window.scrollTo(0, 700);

    },
    booking() {  // 预约
      if (!this.token) {
        this.showLogin = true;
        return false;
      }
      if (this.serviceType == 10 && (this.user.attachCorpId>0 || this.user.bindParkInfo.length>0) ) {
        this.submitSuccessFlag = true;
        this.tipsMsg = '入驻服务仅限普通用户';
        return;
      }

      if (this.formInfo.formType == 3) {  // 富文本+表单
        this.modalShow = true;
      } else {
        // 直接预约接口
        this.submitForm();
      }
    },
    getServiceList() {  // 获取服务列表
      this.loading = true;
      this.$http.post(`${this.URL_PREFIX}/app/get/park/service/list`, {
        parkId: this.currentParkId,
        parentId: this.serviceMsg.serviceId,
      }).then((response) => {
        const res = response.data;
        this.loading = false;
        if (res.resCode === '10000') {
          this.serviceList = res.resData.pageList ? res.resData.pageList : [];
          if (this.serviceList.length) {
            this.serviceId = this.$route.params.serviceId;
            for(let i=0; i<this.serviceList.length; i++){
              if(this.serviceList[i].serviceId == this.serviceId){
                this.selectIndex = i
                this.childName = this.serviceList[i].serviceName
              }
            }
            this.getInfo();
          }
        }
      });
    },
    closeModal() {  // 关闭模态
      this.modalShow = false;
      this.$refs.customForm.resetForm();
    },
    getbianm(){
      this.$http.post(`${this.URL_PREFIX}/app/get/user/info/detail`, {},{
        headers: { token: this.token },
      }).then((respon) => {
        const res = respon.data;
        if(res.resCode === '10000') {
          this.mobile = res.resData.userMobile;
          this.userId = res.resData.userId;
          this.realName = res.resData.realName;
        }
      });
    },
    getInfo() {  // 获取详情
      this.loading = true;
      this.$http.post(`${this.URL_PREFIX}/app/get/park/service/form/tree`, {
        parkId: this.currentParkId,
        serviceId: this.serviceId,
      }, {
        headers: { token: this.token, },
      }).then((response) => {
        this.loading = false;
        const res = response.data;
        if (res.resCode === '10000') {
          this.serviceType = res.resData.type;
          this.content = res.resData.content;
          this.isText = res.resData.formType;  // 判断内容
          this.totalScoreNum = res.resData.totalScoreNum;
          this.score = res.resData.totalScoreNum ? res.resData.totalScore/res.resData.totalScoreNum : 0;
          this.formInfo = res.resData.formTreeDto ? deepcopy(res.resData.formTreeDto) : {};
        }
      });
    },
    submitForm(content) {  // 提交表单
        this.getbianm();
      if (this.serviceType == 10 && (this.user.attachCorpId>0 || this.user.bindParkInfo.length>0) ) {
        this.closeModal();
        this.submitSuccessFlag = true;
        this.tipsMsg = '入驻服务仅限普通用户';
        return;
      }
      const orderBody = {
        parkId: this.currentParkId,
        serviceId: this.serviceId,
      }
      if (this.isText !== 1) {
        orderBody.formId = this.formInfo.formId;
        orderBody.content = content;
      }
      // let newData = {
      //     formData:orderBody,
      //     location:this.currentParkId,
      //     userinfo:{
      //       mobile:'13725530847',
      //     }
      // };
      let url = this.serviceType==18 ? '/app/added/maintain/order' : '/app/added/park/service/form/order';

      this.$http.post(`${this.URL_PREFIX}`+url, orderBody,
      {
        headers: { token: this.token, },
      }).then((response) => {
        const res = response.data;
        this.submitSuccessFlag = true;
        if (res.resCode === '10000') {
          let newData = {
              formData:orderBody,
              location:this.currentParkId,
              userinfo:{
                mobile : this.mobile,
                userId : this.userId,
                realName : this.realName,
              }
          };
          axios.post('http://www.tianans.com/api/shuishoup/api.php?action=sync', {
                newData
            })
            .then(function (response) {
              console.log(response);
            })
            .catch(function (error) {
              console.log(error);
          });
          if (this.isText === 3) {
            this.closeModal();
          }
          this.tipsMsg = '提交成功！请等待管理员审核。';
          if (res.resData.orderFee && res.resData.orderFee !== 0) {
            this.$router.push({
              path: `/navigator/pay/paymentPage`,
              query: {
                'orderId': res.resData.orderId,
                'price': this.orderFee/100,
                'orderType': 3,
              }
            });
          }
        } else {
          this.tipsMsg = res.resDesc;
        }
      });
    },
  },
  created() {
    if (this.parkServiceList.length) {
      this.serviceMsg = this.parkServiceList.find((val) => {
        return val.serviceFlag === 1;
      });
      this.getServiceList();
    }
  },
  computed: {
    ...mapGetters(['currentParkId', 'token', 'user', 'parkServiceList']),
  },
  updated () {
    const imgs = this.$refs.text.querySelectorAll('img');
    const videos = this.$refs.text.querySelectorAll('video');
    imgs.forEach((val) => {
      val.style.maxWidth = '100%';
    });
  },
}
</script>

<style lang="scss" scoped>
@import "~@scss";
.tips{
  height: 100px !important;
}
.property{
  padding-bottom: 18px;
}
/*导航条*/
.nav {
  margin-top: 20px;
  li {
    float: left;
    height: 86px;
    width: 284px;
    margin-right: 20px;
    margin-bottom: 20px;
    background-color: #fff;
    font-size: 24px;
    box-sizing: border-box;
    color: #333;
    border: 1px solid #fff;
    cursor: pointer;
    display: flex;
    align-items: center;
    padding: 38px;
    &:nth-of-type(4n) {
      margin-right: 0;
    }
    &.Select{
      border-color: #d9262c;
    }
    img {
      width: 44px;
      height: 44px;
      margin-right: 18px;
    }
    span {
      display: inline-block;
      width: 180px;
    }
  }
}
.rate{
  float: right;
  margin-top: -19px;
}

/*富文本*/
.content {
  min-height: 200px;
  margin-top: 20px;
  margin-bottom: 20px;
  background-color: #fff;
  padding: 34px 40px 34px 0;
  h4{
    font-weight: bold;
    color: #000;
    font-size: 16px;
    padding-left: 40px;
  }
  .button {
    margin: 0 auto;
    margin-top: 30px;
  }
  .goodsContent {
	padding-left: 40px;
  }
  h3 {
    text-align: center;
    font-size: 20px;
    font-weight: 600;
    margin-bottom: 20px;
  }
}
.submit-success {
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.textOver2{
  text-overflow: ellipsis;
  white-space: nowrap;
}

</style>


// WEBPACK FOOTER //
// src/pages/navigator/property/Property.vue